import React, { useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Avatar } from "antd";
import LookupDisplayCard from "./LookupDisplayCard";
import { useHoverVisibility } from "../Components/Utility";
import { BASE_URL } from "../Components/Constant";

export const LookupCell = ({ lookupId, field, ob }) => {
  const {
    isHovered,
    isVisible,
    handleMouseEnter,
    handleMouseLeave,
    handleContentMouseEnter,
    handleContentMouseLeave,
  } = useHoverVisibility();

  const ref = useRef(null);
  const textRef = useRef(null); // 👈 new ref for text element
  const [placement, setPlacement] = useState("right");
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [showCard, setShowCard] = useState(false);
  const delayTimer = useRef(null);

  if (!lookupId?._id) return null;

  const handleEnter = (e) => {
    handleMouseEnter(e);
    clearTimeout(delayTimer.current);

    // 👇 measure text content specifically, not the whole container
    const rect = textRef.current?.getBoundingClientRect();
    const cardWidth = 260;
    const margin = 8;
    const viewportWidth = window.innerWidth;

    let left, newPlacement;
    if (rect.right + margin + cardWidth < viewportWidth) {
      // enough space on right
      left = rect.right + margin + window.scrollX;
      newPlacement = "right";
    } else {
      // show on left
      left = rect.left - cardWidth - margin + window.scrollX;
      newPlacement = "left";
    }

    setPosition({
      top: rect.top + window.scrollY,
      left,
    });
    setPlacement(newPlacement);

    delayTimer.current = setTimeout(() => setShowCard(true), 400);
  };

  const handleLeave = () => {
    handleMouseLeave();
    clearTimeout(delayTimer.current);
    setShowCard(false);
  };

  return (
    <div ref={ref} onMouseEnter={handleEnter} onMouseLeave={handleLeave}>
      <a
        href={`/record/${ob}/${lookupId?._id}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "flex", alignItems: "center", textDecoration: "none" }}
      >
        {lookupId?.image ? (
          <img
            // src={`data:image/png;base64,${lookupId?.image}`}
            src={`${BASE_URL}/ImageUpload/${lookupId?.org_id}/${lookupId?.image}.png`}
            alt="profile"
            style={{
              width: 16,
              height: 16,
              borderRadius: "50%",
              objectFit: "cover",
              marginRight: 5,
            }}
          />
        ) : (
          <Avatar
            size={16}
            style={{
              backgroundColor: "#87d068",
              marginRight: 5,
              fontSize: 8,
              lineHeight: "12px",
            }}
          >
            {lookupId?.Name?.charAt(0).toUpperCase()}
          </Avatar>
        )}
        {/* 👇 anchor position to this span specifically */}
        <span ref={textRef}>{lookupId?.Name}</span>
      </a>

      {isHovered &&
        isVisible &&
        showCard &&
        ReactDOM.createPortal(
          <div
            style={{
              position: "absolute",
              top: position.top,
              left: position.left,
              zIndex: 2000,
            }}
            onMouseEnter={handleContentMouseEnter}
            onMouseLeave={handleContentMouseLeave}
          >
            <LookupDisplayCard
              displayFields={field?.lookup_config?.display_fields}
              fieldValue={lookupId}
              objectName={field.parent_object_name}
              placement={placement}
            />
          </div>,
          document.body
        )}
    </div>
  );
};